import { styled } from "@material-ui/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import React from "react";
import PropTypes from "prop-types";

const DarkTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#505050",
    color: "#fff",
    // color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 1px 1px grey",
    fontSize: 11,
  },
}));

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 1px 1px grey",
    fontSize: 11,
  },
}));

const TooltipBasic = ({ children, lightMode, tooltipProps }) => {
  const { title, ...tooltipPropsRest } = tooltipProps;
  if (lightMode)
    return (
      <LightTooltip title={title} placement="right" {...tooltipPropsRest}>
        {children}
      </LightTooltip>
    );

  return (
    <DarkTooltip title={title} placement="right" {...tooltipPropsRest}>
      {children}
    </DarkTooltip>
  );
};

TooltipBasic.propTypes = {
  children: PropTypes.node,
  lightMode: PropTypes.bool,
  tooltipProps: PropTypes.objectOf(PropTypes.any),
};

TooltipBasic.defaultProps = {
  children: null,
  lightMode: false,
  tooltipProps: {},
};

export default TooltipBasic;
